/* Trio Flex — interactivity.js
   Cursor follower (dot + lagging ring with data-cursor-text labels)
   + right-side section navigation dots.
   Faithful port of the React CursorFollower / SectionDots components. */
(function () {
  "use strict";

  /* ---------------- Cursor follower ---------------- */
  function initCursor() {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (document.getElementById("tf-cursor-ring")) return;

    var ring = document.createElement("div");
    ring.id = "tf-cursor-ring";
    ring.setAttribute("aria-hidden", "true");
    ring.dataset.hover = "false";
    ring.dataset.hasLabel = "false";
    var label = document.createElement("span");
    ring.appendChild(label);

    var dot = document.createElement("div");
    dot.id = "tf-cursor-dot";
    dot.setAttribute("aria-hidden", "true");

    document.body.appendChild(ring);
    document.body.appendChild(dot);

    var mouseX = window.innerWidth / 2, mouseY = window.innerHeight / 2;
    var ringX = mouseX, ringY = mouseY, raf = 0;

    window.addEventListener("mousemove", function (e) {
      mouseX = e.clientX; mouseY = e.clientY;
      dot.style.transform = "translate3d(" + (mouseX - 3) + "px," + (mouseY - 3) + "px,0)";
    }, { passive: true });

    function tick() {
      ringX += (mouseX - ringX) * 0.18;
      ringY += (mouseY - ringY) * 0.18;
      ring.style.transform = "translate3d(" + (ringX - 24) + "px," + (ringY - 24) + "px,0)";
      raf = requestAnimationFrame(tick);
    }
    raf = requestAnimationFrame(tick);

    window.addEventListener("mouseover", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var interactive = t.closest("[data-cursor-text], a, button, [role='button']");
      var txt = interactive ? (interactive.getAttribute("data-cursor-text") || "") : "";
      ring.dataset.hover = interactive ? "true" : "false";
      ring.dataset.hasLabel = txt ? "true" : "false";
      label.textContent = txt;
    }, { passive: true });
  }

  /* ---------------- Section nav dots ---------------- */
  function initSectionDots() {
    var nav = document.getElementById("tf-section-dots");
    if (!nav) return;
    var buttons = Array.prototype.slice.call(nav.querySelectorAll("[data-target]"));
    if (!buttons.length) return;

    function sectionEls() {
      return buttons.map(function (b) {
        return document.getElementById(b.getAttribute("data-target"));
      });
    }

    var raf = 0;
    function update() {
      var els = sectionEls();
      var probe = window.innerHeight * 0.35;
      var currentIdx = 0;
      els.forEach(function (el, i) {
        if (el && el.getBoundingClientRect().top - probe <= 0) currentIdx = i;
      });
      buttons.forEach(function (b, i) { b.dataset.active = (i === currentIdx) ? "true" : "false"; });
    }
    function onScroll() { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }

    buttons.forEach(function (b) {
      b.addEventListener("click", function () {
        var el = document.getElementById(b.getAttribute("data-target"));
        if (!el) return;
        var y = el.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: y, behavior: "smooth" });
      });
    });
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    update();
  }

  function init() { initCursor(); initSectionDots(); }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", initSectionDots);
})();
